import React from 'react';
import { useProductImage } from '../../hooks/useProductImage';

const defaultPlaceholderStyle = {
  height: '200px',
  backgroundColor: '#f0f0f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

/**
 * Renders a product image from a Firebase Storage path.
 */
export default function ProductImage({
  imagePath,
  altText = '',
  className = 'card-img-top',
  style = { height: '200px', objectFit: 'cover' },
  onClick,
  clickable = false,
  clickableOverlayText,
  placeholderStyle,
  loadingLabel = 'Loading Image...',
  blobLabel = 'Blob Image (Local Preview)',
}) {
  const { imageUrl, loading, isBlob } = useProductImage(imagePath);
  const placeholder = { ...defaultPlaceholderStyle, ...placeholderStyle };
  const imageStyle = {
    ...style,
    cursor: clickable ? 'pointer' : style.cursor,
  };

  if (isBlob && !imageUrl) {
    return (
      <div className={className} style={placeholder} role="img" aria-label={altText}>
        <span>{blobLabel}</span>
      </div>
    );
  }

  if (!imageUrl) {
    return (
      <div className={className} style={placeholder} role="img" aria-label={altText}>
        <span>{loading ? loadingLabel : loadingLabel}</span>
      </div>
    );
  }

  const img = (
    <img
      src={imageUrl}
      className={className}
      alt={altText}
      style={imageStyle}
      onClick={!clickable ? onClick : undefined}
    />
  );

  if (clickable) {
    return (
      <div
        role="button"
        tabIndex={0}
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.(e);
          }
        }}
        title={clickableOverlayText || 'View product'}
        className="product-image-link position-relative"
        style={{ cursor: 'pointer' }}
      >
        {img}
        {clickableOverlayText && (
          <div
            className="position-absolute bottom-0 start-0 end-0 text-white text-center small py-1"
            style={{ background: 'rgba(0,0,0,0.45)' }}
          >
            {clickableOverlayText}
          </div>
        )}
      </div>
    );
  }

  return img;
}
